import * as seed from '../data/portal'

/**
 * The preview's stand-in for PostgreSQL. One mutable copy of the seed tables,
 * plus a version counter that every write bumps. Screens subscribe to the
 * counter and refetch, which is also how they refetch in live mode after a
 * mutation.
 *
 * Only lib/portalApi.ts and lib/portalAuthApi.ts may read or write these tables.
 * Screens go through the API functions, which apply the tenancy and role checks,
 * so the preview behaves like row level security rather than trusting the
 * interface to hide things.
 */

function clone<T>(value: T): T {
  return JSON.parse(JSON.stringify(value)) as T
}

export const db = {
  products: clone(seed.PRODUCTS),
  organisations: clone(seed.ORGANISATIONS),
  users: clone(seed.USERS),
  orgMembers: clone(seed.ORG_MEMBERS),
  projects: clone(seed.PROJECTS),
  projectMembers: clone(seed.PROJECT_MEMBERS),
  tasks: clone(seed.TASKS),
  deliverables: clone(seed.DELIVERABLES),
  conversations: clone(seed.CONVERSATIONS),
  messages: clone(seed.MESSAGES),
  messageReads: clone(seed.MESSAGE_READS),
  invoices: clone(seed.INVOICES),
  payments: clone(seed.PAYMENTS),
  auditLog: clone(seed.AUDIT_LOG),
  notifications: clone(seed.NOTIFICATIONS),
}

let version = 0
const listeners = new Set<() => void>()

/** Call after any write, in preview or live, so subscribed screens refetch. */
export function commit(): void {
  version += 1
  listeners.forEach((listener) => listener())
}

export function subscribe(listener: () => void): () => void {
  listeners.add(listener)
  return () => listeners.delete(listener)
}

export function getVersion(): number {
  return version
}
